/** @fileoverview Shared visual separator; surrounding workspaces supply section labels and meaning. */
import React from 'react';
export function Divider() { return <hr style={{ width: '100%', border: 0, borderTop: '1px solid var(--surface-border)' }} />; }
